module.exports = __webpack_public_path__ + "assets/bca3a876813b8ee75f40bab4ff8de20b.jpg";